import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import ImageCard from "../../components/card/ImageCard";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { statusShowMock, tokenMock } from "../../helper/mock";
import PreviewFile from "../../components/PreviewFile";
import { $api } from "../../helper";
import { useNavigate, useSearchParams } from "react-router";

export default function AddTestimonial() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/testimonial-home/",
  );
  const update = $api.useMutation("put", "/site-api/v1/testimonial-home/");
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/testimonial-home-detail/",
  );
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد نظر ویژه");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            testimonial_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      setFile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.image ?? ""),
          id: detail.data.data.u_id,
        },
      ]);
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      name: string;
      country: string;
      city: string;
      description: string;
      status: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("status", values.status);
    formData.append("country", values.country);
    formData.append("city", values.city);
    formData.append("description", values.description);
    if (searchParams.get("u_id")) {
      formData.append(
        "testimonial_u_id",
        searchParams.get("u_id")?.toString() ?? "",
      );
    }
    formData.append("image", file?.at(0)?.file ?? file?.at(0)?.fileUrl ?? "");
    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/testimonial");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/testimonial");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به نظر"
        title="اطلاعات اصلی نظر"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"name"}
            rules={requireRules("نام کاربر")}
            className="col-span-1"
            label="نام کاربر"
            inputProps={{
              placeholder: "لطفا نام کاربر خود را وارد کنید.",
            }}
          />
          <FormItemInput
            name={"country"}
            rules={requireRules("نام کشور")}
            className="col-span-1"
            label="کشور"
            inputProps={{
              placeholder: "لطفا نام کشور خود را وارد کنید.",
            }}
          />
          <FormItemInput
            name={"city"}
            rules={requireRules("نام شهر")}
            className="col-span-1"
            label="شهر"
            inputProps={{
              placeholder: "لطفا نام شهر خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
          <FormItemInputTextarea
            rules={requireRules("توضیحات")}
            label="توضیحات"
            name={"description"}
            className="col-span-full"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا توضیحات خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormCard
        subTitle="تصاویر مربوط به نمایش کاربر در نسخه‌های مختلف"
        title="تصاویر کاربر"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              file={file}
              setFile={setFile}
              id="image1-1"
              name="desktop_image"
            />
            {file?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFile}
                  url={e.fileUrl}
                  key={"preview-category" + i}
                />
              </div>
            ))}
          </div>
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
